import { gql } from '@apollo/client'

export const CHANGE_SETTING = gql`
  mutation ChangeSetting($input: PlanSettingInput) {
    changeSetting(input: $input) {
      plan_settings_id
      plan_type
      setting_key
      setting_value
      parent
    }
  }
`

export const CHANGE_SETTINGS = gql`
  mutation ChangeSettings($input: [PlanSettingInput]) {
    changeSettings(input: $input) {
      plan_settings_id
      plan_type
      setting_key
      setting_value
      parent
    }
  }
`

export const CHANGE_USER_SETTINGS = gql`
  mutation ChangeUserSettings($input: [UserSettingInput]!) {
    changeUserSettings(input: $input) {
      setting_key
      setting_value
    }
  }
`
